import styled from 'styled-components';
import { ListLinkWithPrefetch } from '@frameio/shared/routing/components/ListLinkWithPrefetch';

export const HiddenLink = styled(ListLinkWithPrefetch)`
  inset: 0;
  pointer-events: none;
  position: absolute;
`;
